import { fg } from '@atlaskit/platform-feature-flags';

import { type EditorAPI } from '../../types';

type ContentData = {
	data: string;
};

interface getCustomBridgeMethodsParams {
	isEditing: boolean;
	localId: string;
	editorAPI?: EditorAPI;
}

export const getCustomBridgeMethods = ({
	isEditing,
	localId,
	editorAPI,
}: getCustomBridgeMethodsParams) => {
	if (!fg('confluence_forge_bridge_custom_methods') || !isEditing) {
		return undefined;
	}

	const getEditorContent = async () => {
		return new Promise((resolve) => {
			editorAPI?.core?.actions.requestDocument((doc) => {
				if (!doc) {
					resolve({ data: '' });
				} else {
					resolve({ data: JSON.stringify(doc) });
				}
			});
		});
	};

	const getMacroContent = async () => {
		const extensionAPI = editorAPI?.extension?.actions?.api();
		if (!extensionAPI) {
			throw new Error('Unable to get macro content: extensionAPI is not available');
		}

		try {
			const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(localId);
			const { node } = nodeWithPos;

			return { data: JSON.stringify(node) };
		} catch (error) {
			throw new Error(`Failed to get macro: ${error}`);
		}
	};

	const updateMacro = async (newExtensionContent: ContentData) => {
		if (!newExtensionContent?.data) {
			return false;
		}

		try {
			const newExtensionData = JSON.parse(newExtensionContent.data);
			const extensionAPI = editorAPI?.extension?.actions?.api();

			if (extensionAPI && newExtensionData) {
				extensionAPI.doc?.update(localId, () => newExtensionData);
				return true;
			}
		} catch (error) {
			throw new Error(`Failed to update macro: ${error}`);
		}
		return false;
	};

	const bridgeMethods = {
		getEditorContent,
		getMacroContent,
		...(fg('confluence_forge_bridge_update_extension') && { updateMacro }),
	};

	return bridgeMethods;
};
